// 学历
export const educations = [
    { value: 'PRIMARY_AND_LOW', text: '小学及以下' },
    { value: 'JUNIOR_HIGH', text: '初中' },
    { value: 'HIGH', text: '高中' },
    { value: 'BACHELOR_AND_ABOVE', text: '本科及以上' },
];
